import { PureComponent, ReactNode } from 'react';
import Fuse from 'fuse.js';

import PadV2AutoSuggest, {
    AllOptions,
    AS_OPTIONS_FREQUENCTLY,
    AS_OPTIONS_SEARCH,
} from './PadV2AutoSuggest';
import { GVitals } from '../../../../../store/db';
import { getGLocal } from '../../../../../store/idbHandler';
import { VitalsEntity } from '../../../../../store/types/prescription';
import { Vitals as VitalIcon } from '../../../../common/Icons';
import { MDBVitalsType, UnitsWithRangesEntity } from '../../../leftPanel/vitals';
import { CUSTOM, GENIE } from '../../../trackSource';
import { LOCAL_ID_PREFIX, VITALS } from '../../../../../constants';
import { VitalsSelectedItemsType } from '../../../../../api/pushGenie';
import { getMyDbId } from '../../../../../api/mactiveid';
import { DB_TABLES } from '../../../../../store/dbTables';

const VITAL_AS_EL_ID = 'VITAL_AS_EL_ID';

const fuseConfig = { keys: ['name'], threshold: 0.3 };

type Props = {
    onSelect: (option: any) => void;
    elements: VitalsSelectedItemsType[];
};

export const API = 'API';
type A = MDBVitalsType & { from: typeof API };
type B = GVitals & { from: typeof GENIE | typeof CUSTOM };
export type AllVitalsType = A | B;

export class VitalAutoSuggest extends PureComponent<Props> {
    fuse = new Fuse<AllVitalsType>([], fuseConfig);
    gElements: AllVitalsType[] | undefined;
    UNITS_MAP: { [key: string]: UnitsWithRangesEntity[] | undefined | null } = {};

    componentDidMount = (): void => {
        getGLocal<GVitals>(getMyDbId() || '', DB_TABLES['vitals']).then((vitals) => {
            const mdbVitals = VITALS.map((v) => ({ ...v, from: API }));
            const gVitals = vitals.map((v) => ({ ...v, from: GENIE }));

            const combined = [...mdbVitals, ...gVitals];
            this.fuse = new Fuse(combined as AllVitalsType[], fuseConfig);
            this.gElements = combined as AllVitalsType[];
            combined.forEach((v) => {
                this.UNITS_MAP[v.id] = v.from === API ? v.units_with_ranges : [];
            });
        });
    };

    getOptions = (
        setOptions: (options: AllOptions<VitalsEntity>, inputValue?: string) => void,
        input?: string,
    ): void => {
        const { elements } = this.props;
        const options: AllOptions<VitalsEntity> = [];

        if (!input) {
            const genieOptions =
                this.gElements
                    ?.filter((gItem) => {
                        return elements.find((ele) => ele.id === gItem.id) ? false : true;
                    })
                    .map((v) => ({
                        ...v,
                        dis_name: v.from === API ? v.dis_name : v.name,
                        value: {
                            qt: '',
                            unit:
                                v.from === GENIE
                                    ? v.unit
                                    : (this.UNITS_MAP[v.id] as UnitsWithRangesEntity[])[0].dis_unit,
                        },
                    })) || [];

            genieOptions.splice(7);

            options.push({
                label: AS_OPTIONS_FREQUENCTLY,
                options: genieOptions,
            });
            setOptions(options, input);
        } else {
            const filteredGItems =
                this.fuse
                    .search(input)
                    .map((option) => option.item)
                    ?.filter((gItem) => {
                        return elements.find((ele) => ele.id === gItem.id) ? false : true;
                    })
                    .map((v) => ({
                        ...v,
                        dis_name: v.from === API ? v.dis_name : v.name,
                        value: {
                            qt: '',
                            unit:
                                v.from === GENIE
                                    ? v.unit
                                    : (this.UNITS_MAP[v.id] as UnitsWithRangesEntity[])[0].dis_unit,
                        },
                    })) || [];

            filteredGItems.splice(7);

            const currentOptions = [
                { label: AS_OPTIONS_SEARCH as typeof AS_OPTIONS_SEARCH, options: filteredGItems },
            ];

            setOptions(currentOptions, input);
        }
    };

    OptionIcon = VitalIcon('fill-darwin-accent-dark-blue-800');

    render(): ReactNode {
        const { elements, onSelect } = this.props;
        return (
            <PadV2AutoSuggest
                elId={VITAL_AS_EL_ID}
                onSelect={onSelect}
                optionIconText={this.OptionIcon}
                optionIconBgClass="circle-vital"
                menuListClassName="vital-dropdown"
                optionWrapperClass="vital-dropdown-item"
                getOptions={this.getOptions}
                placeholder="Start typing a Vital..."
                elements={[]}
                autosuggestHeading="recorded by you"
            />
        );
    }
}

export const removeUnwatedKeys = (vital: VitalsEntity): VitalsEntity => {
    return {
        name: vital.name,
        dis_name: vital.dis_name,
        id: vital.id,
        value: vital.value,
        interpretation: undefined,
        date: new Date().toISOString(),
        remark: undefined,
        locked: vital.locked,
    };
};
